import React from "react";

const EmailIcon = ({ fill = "#387CFF", stroke = "#387CFF", ...props }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props} // Spread additional props (e.g., className, style)
  >
    <path
      d="M2.25 4.5H15.75M2.25 4.5V13.5C2.25 13.9142 2.58579 14.25 3 14.25H15C15.4142 14.25 15.75 13.9142 15.75 13.5V4.5M2.25 4.5L8.58397 8.72265C8.8359 8.8906 9.1641 8.8906 9.41603 8.72265L15.75 4.5"
      stroke={fill}
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
  </svg>
);
export default EmailIcon;
